export const CampaignsQueryKeys = {
  GET_ALL: (merchantId: string, venueIds?: string[]) => ['self-service-promotions', 'promotions', merchantId, venueIds],
  GET_ALL_ADS: (venueId: string) => ['ads', venueId],
  GET_SINGLE: (merchantId: string, campaignId: string) => [
    'self-service-promotions',
    'promotions',
    merchantId,
    campaignId,
  ],
  GET_SINGLE_ADS: (venueId: string, campaignId: string) => ['ads', venueId, campaignId],
  GET_ITEM: (menuId: string, itemId: string) => ['menu', 'item', menuId, itemId],
  GET_ADS_VENUE_CONFIG: (venueId: string, country: Country) => ['venues', 'configuration', venueId, country],
  GET_CONFIG: (merchantId: string, venueIds: string[]) => [
    'self-service-promotions',
    'config_v2',
    merchantId,
    venueIds,
  ],
  GET_AUTHOR: (authorId: string) => ['users', authorId],
};
